export function isValidChimeUrl(urlString: string): boolean {
  try {
    const url = new URL(decodeURI(urlString));

    const matchedDomain = ["chime.com", "chm.life"].find(allowedUrl => {
      return url.hostname.endsWith(allowedUrl);
    });

    return matchedDomain !== undefined;
  } catch {
    return false;
  }
}
